// extracted by mini-css-extract-plugin
export default {"tagSelected":"TagsSelected_tagSelected__Fjp1c","nameTag":"TagsSelected_nameTag__bxpEG","deleteImg":"TagsSelected_deleteImg__pGq8I"};